/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { questionStatus } from '../../util/attendExamConst'
import { convertImageToBase64 } from '../../util/Base64Convert'
import { shuffleArray } from '../../util/utils'
import { ActionTypes } from '../action'
import { AttendExamData } from '../Actions'
import {
  ATTEND_EXAM,
  START_EXAM,
  SUBMIT_EXAM,
  UPDATE_QUESTION,
  SAVE_QUESTION_STATUS,
} from '../constants/action-types'

const initialState = {
  isLoading: false,
  errorMessage: '',
  examData: {
    id: '',
    assigned_by: {},
    name: '',
    description: '',
    examination_type: '',
    evaluation_mode: '',
    duration: 0,
    total_marks: 0,
    passing_marks: 0,
  },
  question_paper: {},
  questions: [],
  questionsStatus: [],
}

const reducer = persistReducer(
  { storage, key: 'attend-exam', whitelist: ['examData', 'questionsStatus'] },
  (state: AttendExamData = initialState, action: ActionTypes) => {
    switch (action.type) {
      case ATTEND_EXAM.SET_ATTEND_EXAM_DATA:
        return {
          ...state,
          ...action.payload,
          isLoading: false,
        }
      //Question List
      case START_EXAM.START_EXAM_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: true,
        }
      case START_EXAM.START_EXAM_SUCCESS:
        const res: any = action.payload
        const question_sets = res?.exam_data?.question_list
        const data: any = []
        data.push(...question_sets)
        const randomizeQuestions = res?.exam_data?.randomize
          ? shuffleArray(data)
          : data

        const questions = randomizeQuestions.map((item, index) => {
          // url to base54 for body images
          item?.body_images.map((img, idx) => {
            convertImageToBase64(img?.image, (val) => {
              questions[index].body_images[idx].image = val
            })
          })

          // url to base54 for options images
          item?.options.map((img, i) => {
            convertImageToBase64(img?.image, (val) => {
              questions[index].options[i].image = val
            })
          })

          return {
            ...item,
            attempt_status: questionStatus.unanswered,
            options: item?.options?.map((i) => {
              return {
                ...i,
                is_selected: false,
                essay_answer: '',
                markedForReview: false,
              }
            }),
            startTime: 0,
            endTime: 0,
            totalTime: 0,
            isOffline: false,
            submitPayload: {},
          }
        })

        return {
          ...state,
          errorMessage: '',
          isLoading: false,
          question_paper: res,
          questions: questions,
        }

      case START_EXAM.START_EXAM_ERROR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
        }
      case UPDATE_QUESTION.SET_QUESTION:
        return {
          ...state,
          ...action.payload,
          isLoading: false,
          questions: action.payload,
        }
      //Question List
      case SUBMIT_EXAM.SUBMIT_EXAM_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: true,
        }
      case SUBMIT_EXAM.SUBMIT_EXAM_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
        }

      case SUBMIT_EXAM.SUBMIT_EXAM_ERROR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
        }

      case SAVE_QUESTION_STATUS.SAVE_QUESTION_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          questionsStatus: action.payload,
          isLoading: false,
        }

      default:
        return state
    }
  }
)

export default reducer
